<template>
    <el-form ref="form" :model="form" :rules="rules" label-width="180px" class="add-clue-form" >
        <el-form-item label="申请人姓名" prop="contact_name" >
            <el-input class="clue-edit-input" v-model="form.contact_name" ></el-input>
        </el-form-item>
        <el-form-item label="申请人手机" prop="mobile">
            <el-input class="clue-edit-input" v-model="form.mobile" ></el-input>
        </el-form-item>
        <el-form-item label="申请人QQ" prop="qq" >
            <el-input class="clue-edit-input" v-model="form.qq" ></el-input>
        </el-form-item>
        <el-form-item label="所在单位" prop="customer_name" >
            <el-input class="clue-edit-input" v-model="form.customer_name" ></el-input>
        </el-form-item>
        <el-form-item label="客户类型" prop="customer_type" >
            <el-radio v-model="form.customer_type" :label="key" v-for="(type,key) in customerType" :key="key" :value="key" >{{type}}</el-radio>
        </el-form-item>
        <el-row class="clue-area">
            <el-col :span="10">
                <DistrictLinkage :provinceId="form.province_id" :cityId="form.city_id" :districtId="form.district_id" @change="handleChange"></DistrictLinkage>
            </el-col>
        </el-row>
        <el-form-item label="意向产品" prop="product_ids" class="clueProducts">
            <el-checkbox-group v-model="form.product_ids" class="product-use">
                <el-checkbox v-for="(product, index) in productList" :key="index" :label="parseInt(product.id)">{{product.name}}</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="线索来源" prop="source">
            <ChannelCascader v-if="model && form.hasOwnProperty('channel')" :channel="form.channel" @change="channelHandleChange" :isUrl="true"></ChannelCascader>
        </el-form-item>
        <el-form-item label="分配方式" prop="allocation_type" v-if="$route.path == '/sales-leads/create'">
            <el-radio-group v-model="form.allocation_type">
                <el-radio :label="1">系统分配</el-radio>
                <el-radio :label="2">指定业务员</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.allocation_type == 2 && $route.path == '/sales-leads/create'" label="业务员" prop="user_id">
            <UserSelect1 v-model="form.user_id" :uid="form.user_id" @change="UserHandleChange"></UserSelect1>
        </el-form-item>
        <el-collapse class="clue-info-collapse" >
            <el-collapse-item title="展开更多信息" name="1">
                <el-form-item label="学校班级数" prop="class_num" >
                    <el-input class="clue-edit-input" v-model="form.class_num" ></el-input>
                </el-form-item>
                <el-form-item label="学校老师数" prop="teacher_num">
                    <el-input class="clue-edit-input" v-model="form.teacher_num" ></el-input>
                </el-form-item>
                <el-form-item label="校长或主任姓名" class="clue-leader-name">
                    <el-input placeholder="请输入领导姓名" v-model="form.leader_name" class="clue-leader-select" >
                        <el-select v-model="form.leader_job" placeholder="请选择" slot="prepend" @change="handleChangeJob" >
                            <el-option :label="job" :value="key" v-for="(job,key) in leaderType" :key="key" ></el-option>   
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="校长或主任电话" prop="leader_mobile">
                    <el-input class="clue-edit-input" v-model="form.leader_mobile" ></el-input>
                </el-form-item>
                <el-form-item v-if="$route.path === '/sales-leads/create'" label="备注" prop="memo">
                    <el-input
                        class="clue-edit-input"
                        v-model="form.memo"
                        type="textarea"
                        :rows="3"
                        maxlength="255"
                        placeholder="请输入备注">
                    </el-input>
                </el-form-item>
            </el-collapse-item>
        </el-collapse>
        <el-form-item class="clue-btn" >
            <el-button type="primary" @click="submitForm()">保存</el-button>
            <el-button @click="resetForm()">取消</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import ProductService from "~/services/product"
import ClueService from "~/services/SaleClues"
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import ChannelCascader from "~/widgets/ChannelCascader.vue";
import UserSelect1 from "~/widgets/UserSelectCorp.vue";
import { Regexp } from "~/config/params";
export default {
    name: "clueForm",
    components: {
        DistrictLinkage,
        ChannelCascader,
        UserSelect1
    },
    data() {
        //记笔记： 自定义验证规则之后一定要加上else callback();否则validate方法不会执行，表单提交不了！！！
        var validateSource = (rule, value, callback) => {
            if(!this.form.source || this.form.source <= 0) {
                callback(new Error('请选择线索来源'));
            }else {
                callback();
            }
        };
        return {
            select: '',
            rules: {
                customer_name: [
                    {
                        required: true,
                        message: "请输入客户名称",
                        trigger: "blur"
                    }
                ],
                product_ids: [
                    {
                        required: true,
                        message: "请选择意向产品",
                        trigger: "change"
                    }
                ],
                customer_type: [
                    {
                        required:true,
                        message: "请选择客户类型",
                        trigger : "change"
                    }
                ],
                contact_name: [
                    {
                        required: true,
                        message: "请填写联系人姓名",
                        trigger: "blur"
                    }
                ],
                mobile: [
                    {
                        required: true,
                        message: "请填写联系人电话",
                        trigger: "blur"
                    },
                    // {
                    //     pattern: Regexp.mobile,
                    //     message:"手机号码不正确",
                    //     trigger: "blur"
                    // }
                ],
                qq: [
                    {
                        pattern: Regexp.qq,
                        message: "联系人qq号码格式不正确",
                        trigger: "blur"
                    }
                ],
                source: [
                    {
                        required: true,
                        // message:"请选择线索来源",
                        validator : validateSource,
                        trigger : "blur"
                    }
                ],
                user_id: [
                    {
                        required: true,
                        message:"请选择业务员",
                        trigger : "change"
                    }
                ],
                class_num: [
                    {
                        pattern: Regexp.num,
                        message: "班级数应为数值",
                        trigger: "blur"
                    }
                ],
                teacher_num: [
                    {
                        pattern: Regexp.num,
                        message: "教师数应为数值",
                        trigger: "blur"
                    }
                ],
                // leader_mobile: [
                //     {
                //         //pattern: Regexp.phone_number,
                //         message: "请正确填写电话号码",
                //         trigger: "blur"
                //     }
                // ],
                province_id: [
                    {
                        required: true,
                        message: "请选择所在地区",
                        trigger: "change"
                    }
                ],
                city_id: [
                    {
                        required: true,
                        message: "请选择所在地区",
                        trigger: "change"
                    }
                ],
                district_id: [
                    {
                        required: true,
                        message: "请选择所在地区",
                        trigger: "change"
                    }
                ]
            },
            customerType: {},   //存取客户类型对象
            leaderType: {},     //存取领导类型对象
            productList: [],     //存取产品信息
            productss: [],
            form: {
                contact_name: '',
                mobile: '',
                qq: '',
                customer_name: '',
                customer_type: '',
                province_id: 0,
                city_id: 0,
                district_id: 0,
                product_ids: [],
                class_num: '',
                teacher_num: '',
                leader_name: '',                
                leader_mobile: '',
                memo: '',
                source: '',
                leader_job: '',
                user_id: this.$store.getters.userId,
                username: '',
                allocation_type: 2,
                channel: {pid: 0, id: 0}
            },
        }
    },
    props: {
        model: {
            type: Object,
            required: false,
            value: function () {
                return null;
            }
        },
        isEdit: {
            type: Boolean,
            default: false
        },
    },
    created() {
        Object.keys(this.form).forEach(key => {
            if (this.model.hasOwnProperty(key)) {
                this.form[key] = this.model[key];
            }
        });
        this.customerType = ClueService.getCustomerType();
        this.leaderType = ClueService.getLeaderType();
        this.getProducts();
    },
    methods: {
        handleChangeJob(val) {
            this.form.leader_job = val;
        },
        // 获取产品信息
        getProducts() {
            ProductService.getOptionList().then( res => {
                if(res.code == 0) {
                    this.productList = res.data;
                }
            });
        },

        // 提交表单
        submitForm() {
            if(this.$route.path == '/sales-leads/create' && this.form.allocation_type != 2){
                delete this.form.user_id;
            }
            this.$refs["form"].validate( valid => {
                if(valid) {
                    this.$emit("submit", this.form);
                } else {
                    return false;
                }
            })
        },
        // 重置表单
        resetForm() {
            this.$refs["form"].resetFields();
            this.form.province_id = '';
            this.form.city_id = '';
            this.form.district_id = '';
            this.form.user_id = '';
            this.$router.push({
                path: this.$route.query.referer 
            });
        },

        //地区联动 Cascader 级联选择器,切换事件,表单model赋值
        handleChange(value) {
            this.form.province_id = Number(value[0]);
            this.form.city_id = Number(value[1]);
            this.form.district_id = Number(value[2]);
        },

        //运营渠道 Cascader 级联选择器,切换事件,表单model赋值
        channelHandleChange(value) {
            if(value && value.length > 0){
                this.form.source = value[value.length - 1].toString();
            }else{
                this.form.source = '';
            }
            this.$refs.form.validateField('source')
        },
        
        //业务员姓名远程搜索组件赋值
        UserHandleChange(value) {
            this.form.user_id = value;
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/clue/form.vue